import {
  cloneDeep,
  pull,
  isArray,
  forOwn,
  trim,
  isObject,
  isString,
  isEmpty,
  isNaN,
  isNull,
  isUndefined
} from 'lodash'

export default function cleanObject(obj) {
  return (function clean(current) {
    forOwn(current, function(value, key) {
      if (
        value === 'null' ||
        isUndefined(value) ||
        isNull(value) ||
        isNaN(value) ||
        (isString(value) && !trim(value)) ||
        (isObject(value) && isEmpty(clean(value)))
      ) {
        delete current[key]
      }
    })

    if (isArray(current)) pull(current, undefined)

    return current
  })(cloneDeep(obj))
}
